const timelineInit = () => {
  const steps = document.querySelectorAll('.timeline__step');

  function viewportDetect(el) {
    const rect = el.getBoundingClientRect();
    return rect.bottom > 0 && rect.top + 250 < (window.innerHeight
        || document.documentElement.clientHeight);
  }

  window.addEventListener('scroll', () => {
    steps.forEach((step, index) => {
      if (viewportDetect(step)) {
        step.classList.add('show-step');
        if (steps.length === index + 1) {
          step.classList.add('show-step-last');
        } else {
          step.classList.add(`show-step-${index + 1}`);
        }
      }
    });
  });
};
export default timelineInit;
